class RecordService {
  public static omit<T extends Record<string, any>>(excludeKeys: string[], obj: T) {
    return Object.fromEntries(Object.entries(obj).filter(([objKey]) => !excludeKeys.includes(objKey)));
  }

  public static cleanRecordFromSpecificValue(record: Record<string, unknown>, value: any) {
    return Object.fromEntries(Object.entries(record).filter(([_, v]) => v !== value));
  }
}

export default RecordService;
